<template>
    <div class="card p-2" style="min-height: 200px">
        <div class="table-responsive">
            <table class="table">
                <thead>
                <tr>
                    <th v-if="showSelect" style="width: 5%">
                        <input
                            type="checkbox"
                            :checked="allSelected"
                            @change="toggleSelectAll($event.target.checked)"
                        >
                    </th>
                    <th style="width:13%">Date</th>
                    <th style="width:13%">Voucher Type</th>
                    <th>Tnx Type</th>
                    <th>Voucher No</th>
                    <th style="width: 20%;">Memo</th>
                    <th>Created By</th>
                    <th>Party</th>
                    <th>Amount</th>
                    <th>Attachments</th>
                    <th style="width:16%">Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in journals" :key="i">
                    <td v-if="showSelect">
                        <input
                            v-if="!isApprovalBlocked(item)"
                            type="checkbox"
                            v-model="item.selected"
                        >
                    </td>
                    <td>
                        <span class="fw-bold">{{ item.formatted_date }}</span>
                    </td>
                    <td>{{ convertToTitleCase(item.voucher_type) }}</td>
                    <td>{{ convertToTitleCase(item.txn_type) }}</td>
                    <td>{{ item.voucher_no }}</td>
                    <td>{{ item.note }}</td>
                    <td>{{ item.updated_by_user ? item.updated_by_user.name : 'N/A' }}</td>
                    <td>{{ item.party ? item.party.name : 'N/A' }}</td>
                    <td class="text-right">{{ commaFormat(item.total_amount) }}</td>
                    <td>
                        <button
                            v-if="item.attachments.length > 0"
                            class="btn btn-primary btn-sm"
                            style="cursor: pointer"
                            @click="viewAttachments(item.attachments)"
                        >
                            <i class="fas fa-eye"></i>
                            View
                        </button>
                        <span v-else class="badge btn-danger">
                                No attachments
                            </span>
                    </td>
                    <td>
                        <button
                            class="btn btn-primary btn-sm me-1"
                            style="cursor: pointer"
                            @click="openDetailModal(item.id, item.voucher_type, item.txn_type)"
                        >
                            <i class="fas fa-eye"></i>
                        </button>
                        <button
                            class="btn btn-secondary btn-sm"
                            style="cursor: pointer"
                            @click="goToPrint(item.id, item.voucher_type)"
                        >
                            <i class="fas fa-print"></i>
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>

            <p v-if="!journals.length" class="text-center mt-5">No data</p>
        </div>

        <ViewAttachment
            ref="viewAttachmentRef"
            :attachments="modalAttachments"
        />

        <VoucherDetailModal
            ref="voucherDetailRef"
            @approved="emit('approved')"
        />
    </div>
</template>

<script setup>
import figureFormatter from '@/services/utils/figureFormatter'
import { computed } from "@vue/runtime-core";
import { useStore } from "vuex";
import ViewAttachment from '@/views/page/company/ngo/voucher/payment/ViewAttachmentModal.vue'
import VoucherDetailModal from '@/views/page/company/core-accounting/voucher/approval/VoucherDetailModal.vue'
import { ref } from 'vue'
import { convertToTitleCase } from '@/services/utils/global';
import handleJournal from '@/services/modules/journal'
import handleCompany from '@/services/modules/company'
import pdfPrinterHelper from '@/services/utils/pdfPrinterHelper'
import { useVoucherPrint } from '@/services/utils/voucherPrint';

defineProps({
    showSelect: { type: Boolean, default: true }
})

const emit = defineEmits(['approved'])

const $store = useStore();
const journals = computed(() => $store.getters["journal/getJournals"]);
const { commaFormat } = figureFormatter();
const { fetchJournal } = handleJournal();
const { fetchActiveCustomizationField } = handleCompany();
const { generatePdf } = pdfPrinterHelper();
const modalAttachments = ref([]);
const viewAttachmentRef = ref();
const voucherDetailRef = ref();
const customizationPdfFields = ref({});
const { printVoucher, vouchers } = useVoucherPrint();

const isApprovalBlocked = (item) => {
    return item.txn_type === 'bill_payment' && item.voucher_type === 'journal_voucher'
}

const selectableJournals = computed(() => {
    return journals.value.filter(journal => !isApprovalBlocked(journal))
})

const allSelected = computed(() => {
    if (!selectableJournals.value.length) return false
    return selectableJournals.value.every(journal => journal.selected === true)
})

const toggleSelectAll = (checked) => {
    selectableJournals.value.forEach(journal => {
        journal.selected = checked
    })
}

const openDetailModal = (id, type, txnType) => {
    if (!voucherDetailRef.value) return
    voucherDetailRef.value.openModal(id, type, txnType)
}

const goToPrint = (id, type) => {
  printVoucher(id, type);
}

const viewAttachments = (attachments) => {
    modalAttachments.value = [];
    modalAttachments.value = attachments;
    if (viewAttachmentRef.value) {
        viewAttachmentRef.value.toggleModal();
    }
}
</script>

<style scoped>
.table > :not(caption) > * > * {
    padding: 0.72rem 0.75rem !important;
}

.table thead th {
    vertical-align: middle !important;
}
</style>